export enum ManagedByParent {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
